import React from "react";

export const RequestDeniedStep = ({ setStep, onClose }) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title red">Request Denied</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>
          {Drupal.t("The bank transfer has been denied and will not be paid.")}
        </p>
      </div>
      {onClose && (
        <div className="authorise-bank-transfer-actions text-center mt-3">
          <button
            type="button"
            className="primary_btn"
            onClick={() => setStep?.("close") || onClose?.()}
          >
            {Drupal.t("Done")}
          </button>
        </div>
      )}
    </div>
  </>
);
